import keymirror from "../utils/keymirror";

export const NotificationsConstants = keymirror(
    {
        OPEN_NOTIFICATIONS_POPOVER: null,
        CLOSE_NOTIFICATIONS_POPOVER: null,
        FETCH_NOTIFICATIONS: null,
        FETCH_NOTIFICATIONS_SUCCESS: null,
        FETCH_NOTIFICATIONS_FAILURE: null,
        SET_OPENED_AT: null,
        SET_OPENED_AT_SUCCESS: null,
        SET_OPENED_AT_FAILURE: null,
        SET_VIEWED_AT: null,
        SET_VIEWED_AT_SUCCESS: null,
        SET_VIEWED_AT_FAILURE: null
    },
    "notifications"
);



// WEBPACK FOOTER //
// ./src/constants/notifications.constants.js